export const NAMESPACE_VISIBILITY_LABEL = 'virtual.konflux-ci.dev/visibility';

export const NAMESPACE_VISIBILITY_VALUES = {
  PRIVATE: 'private',
  AUTHENTICATED: 'authenticated',
};
